import { useSaveQuiz } from '@repo/api/quiz/useSaveQuiz';

import { useQuizResolverStore } from '@/store/quiz-store';

import { useQuizParams } from '.';

export function useQuizQuickSave() {
  const { id, attemptId } = useQuizParams();

  const getExportedAnswers = useQuizResolverStore((state) => state.getExportedAnswers);
  const saveQuizMutation = useSaveQuiz(id, attemptId);

  const quickSave = async (): Promise<string> => {
    const answers = getExportedAnswers();
    return saveQuizMutation.mutateAsync({ answers }).catch((error) => {
      throw error;
    });
  };

  return { quickSave };
}
